module.exports = __webpack_public_path__ + "img/DAY4-2.f21ab0b4.jpg";